// extracted by mini-css-extract-plugin
export default {"location-alert":"right-panel_location-alert__iIMFx","locationAlert":"right-panel_location-alert__iIMFx"};